<template>
  <v-container
    id="detalhe-produtores-ativos-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <v-row v-if="!paginaEnable">
      <h1>
        Usuário não tem permissão a essa página não existente
      </h1>
    </v-row>
    <v-row v-else>
      <v-col
        cols="12"
        lg="12"
        class="px-1"
      >
        <v-row>
          <v-col
            cols="12"
            class="container"
            style="max-width: 100%"
          >
            <v-container>
              <v-col
                cols="12"
              >
                <dashboard-filtro-produtores
                  :primeiro="enablePrimeiroDia"
                  :ultimo="enableUltimoDia"
                  :empresas="enableEmpresa"
                  :url="link"
                  :produtores="enableProdutores"
                  :linhas="enableLinha"
                />
              </v-col>
            </v-container>
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
              >
                <v-card
                  id="cardDashbord"
                  class="mx-auto"
                  outlined
                >
                  <div class="card-header-dashbord">
                    <v-row>
                      <v-col
                        cols="12"
                        sm="10"
                        md="10"
                        lg="10"
                        class="d-flex flex-wrap"
                      >
                        Relatório de Produtores Ativos
                      </v-col>
                      <v-col
                        cols="12"
                        sm="2"
                        md="2"
                        lg="2"
                        class="d-flex justify-end"
                      >
                        <v-tooltip top>
                          <template
                            v-slot:activator="{ on, attrs }"
                          >
                            <v-icon
                              id="iconInformationFatxMetaComercial4"
                              class="text-left"
                              v-bind="attrs"
                              v-on="on"
                            >
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <div
                            v-html="'<span>Este relatório lista todos os produtores que a empresa comprou e não comprou leite no periodo filtrado.</span>'"
                          />
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </div>
                  <v-card-actions>
                    <v-row>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        lg="12"
                      >
                        <div
                          id="idTable"
                          style="overflow-x: auto; max-width: 100%;"
                        >
                          <table
                            style="width: 100%; table-layout: fixed; color: black; border-collapse: collapse;"
                            class="elevation-1"
                          >
                            <thead>
                              <tr>
                                <th
                                  style="text-align: center;"
                                  class="black--text title"
                                >
                                  Produtor
                                </th>
                                <th
                                  style="text-align: center;"
                                  class="black--text title"
                                >
                                  Quantidade de leite(Litros)
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="item in dadosDetalhamento"
                                :key="item.id"
                              >
                                <td
                                  id="dadoMovimentacao"
                                  style="text-align: left;"
                                >
                                  {{ item.cliente }}
                                </td>
                                <td
                                  id="dadoMovimentacao"
                                  style="text-align: right;"
                                >
                                  {{ item.quantidadeleite }}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

    <script>
  import Entregaleite from '../../../../../services/entregaleite'
  import Permissao from '../../../../../services/menu'
  import eventEmit from '../../../components/core/EventoEmit'

  export default {
    name: 'DashboardProdutoresAtivosDetalhamento',
    emits: ['atualizarTexto'],
    components: {
      DashboardCoreSnackbar: () => import('../../../components/core/Snackbar'),
      DashboardFiltroProdutores: () => import('../../../components/core/FiltroProdutores.vue'),
    },

    data: () => ({
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      styleObjectIcon: {
        color: '#4780b8',
      },
      styleObject: {
        color: localStorage.corPrimaria,
      },
      paginaEnable: false,
      primeiroDia: (new Date(localStorage.dataInicial)).toISOString().substr(0, 10),
      ultimoDia: (new Date(localStorage.dataFinal)).toISOString().substr(0, 10),
      select: JSON.parse(localStorage.getItem('empresaSelect')),
      empresa: [],
      produtorSelect: JSON.parse(localStorage.getItem('produtorSelect')),
      produtores: [],
      linhaSelect: JSON.parse(localStorage.getItem('linhaSelect')),
      linhaleite: [],
      menu: false,
      menu1: false,
      loading: false,
      error: null,
      enablePrimeiroDia: true,
      enableUltimoDia: true,
      enableEmpresa: true,
      enableLinha: true,
      link: window.location.href,
      enableProdutores: true,
      headersDetalhamento: [
        { text: 'Produtor', value: 'cliente', width: '300px', class: 'black--text title' },
        { text: 'Quantidade de leite(Litros)', value: 'quantidadeleite', width: '150px', align: 'right', class: 'black--text title' },
      ],
      dadosDetalhamento: [],
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      dynamicPaddingBloco: '',
    }),

    computed: {
      computedDateFormatted () {
        return this.formatDate(this.ultimoDia)
      },

      computedPrimeiroDia () {
        return this.formatDatePrimeiroDia(this.primeiroDia)
      },
    },
    created () {
      eventEmit.$on('update-dados', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados', this.handleUpdateDados)

      window.removeEventListener('resize', this.updateDynamicPadding)
    },

    mounted () {
      window.scrollTo(0, 0)

      this.updateDynamicPadding()

      window.addEventListener('resize', this.updateDynamicPadding)

      eventEmit.$emit('atualizar_texto', 'Produtores')

      if (localStorage.tokencontrato) {
        this.usuarioIdentificado = true

        this.paginaEnable = true

        Permissao.showEmpresas(localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            var i = 0

            for (i in resposta.data.empresas) {
              this.empresa.push(resposta.data.empresas[i])
            }

            for (i in resposta.data.rota) {
              this.rota.push(resposta.data.rota[i])
            }
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        })
      } else {
        this.usuarioIdentificado = false
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        localStorage.removeItem('usuarioIdentificado')
        this.$router.push('/login')
      }
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select, produtor, linha) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = dataFinal
        this.select = select
        this.produtorSelect = produtor
        this.linhaSelect = linha

        localStorage.setItem('updateDadosFiltros', true)
        localStorage.setItem('dataInicial', this.primeiroDia)
        localStorage.setItem('dataFinal', this.ultimoDia)

        this.updateDate()
      },

      formatDate (date) {
        if (!date) {
          return null
        }

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDatePrimeiroDia (date) {
        if (!date) {
          return null
        }

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },

      updateDate () {
        this.dadosDetalhamento = []

        this.showDelhamentoProdutoresAtivos()
      },

      async showDelhamentoProdutoresAtivos () {
        this.loading = true

        await Entregaleite.showDelhamentoProdutoresAtivos(this.primeiroDia, this.ultimoDia, this.select, this.produtorSelect, localStorage.tokencontrato, this.linhaSelect).then(resposta => {
          if (resposta.data.status) {
            this.dadosDetalhamento = resposta.data.totalLeiteProdutoresAtivos.map((item) => {
              var listaDetalhamento = ({
                cliente: item.nome,
                linhaleite: item.linhaleite,
                quantidadeleite: parseFloat(item.qtdleite).toLocaleString('pt-BR'),
              })

              return listaDetalhamento
            })
          } else if (resposta.data.msg === 'Não há dados para o período selecionado') {
            this.dadosDetalhamento = []

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },

      updateDynamicPadding () {
        if (window.innerWidth > 1800) {
          this.dynamicPaddingBloco = 'padding-right: 107rem !important'
        } else if (window.innerWidth > 1380 && window.innerWidth <= 1800) {
          this.dynamicPaddingBloco = 'padding-right: 70rem !important'
        } else if (window.innerWidth > 380 && window.innerWidth < 600) {
          this.dynamicPaddingBloco = 'padding-right: 7rem !important'
        } else {
          this.dynamicPaddingBloco = 'padding-right: 67rem !important'
        }
      },
    },
  }
</script>

<style scoped>
  #cardDashbord {
    border-radius: 14px;
    border: 1px solid rgba(0,0,0,0.05);
    box-shadow:
      0 2px 4px rgba(0,0,0,0.08),
      0 6px 12px rgba(0,0,0,0.06),
      0 12px 24px rgba(0,0,0,0.04);
    transition: all 0.25s ease;
    transform: translateY(-3px);
    box-shadow:
      0 4px 8px rgba(0,0,0,0.10),
      0 12px 22px rgba(0,0,0,0.09),
      0 20px 32px rgba(0,0,0,0.06);
  }

  .card-header-dashbord {
    background-color: #ffffff;
    padding: 14px 18px;
    font-weight: 600;
    font-size: 14px;
    color: black;
    border-bottom: 1px solid #b7b1b1;
    border-radius: 14px 14px 0 0;
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 500px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #idTable {
      max-height: 500px;
      max-width: 410px !important;
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
  }
</style>

<style lang="sass">
  .highlighted-item
    background-color: #2863af
    padding: 16px
    color: white
    margin: -1rem 0 0 0

  #listItemPrincipaisClientes
    margin: -2rem 0 0 -1rem

  #relatorioProdutoresAtivos
    margin-left: 0.5rem
    font-size: 14px
    font-weight: bold

  #iconInformationProdutoresAtivos
    margin-left: 9.5rem
    font-weight: bold

  #headersProdutoresAtivos
    margin-left: 1.7rem
    margin-right: 1.7rem

  .custom-loader
    animation: loader 1s infinite
    display: flex
    @-moz-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @-webkit-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @-o-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)

</style>
